import { useEffect, useState } from "react";
import "./style.scss";
import { useSelector } from "react-redux";
import state from "redux/state";

const CryptoIcon = ({symbol="SOL", size=25}) => {
  const state = useSelector((state) => state.storage);
  const [tokenInfo, setTokenInfo] = useState(null);

  useEffect(() => {
    if(state.tokenList) {
      let tokens = state.tokenList.tokens;
      for(let i = tokens.length-1; i >= 0; i--) {
        if(!tokens[i].symbol) continue;
        if(tokens[i].symbol.toLowerCase() === symbol.toLowerCase() || tokens[i].address.toLowerCase() === symbol.toLowerCase()) {
          setTokenInfo(tokens[i]);
          break;
        }
      }
    }
  },[state.tokenList, symbol])

  if (!tokenInfo)
    setTokenInfo({logoURI:"https://i.imgur.com/WRxAdjU.png"})

  return <>
    {
      tokenInfo &&
      <img onError={(e) => e.target.src="https://i.imgur.com/WRxAdjU.png"} src={tokenInfo.logoURI} width={size} height={size} style={{borderRadius:"50%"}}/>
    }
  </>;
}
export default CryptoIcon;